import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useState, useRef, useEffect } from "react";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Paper from "@mui/material/Paper";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
    GENDER_DETAILS,
    GST_PERCENTAGE,
    MINIMUM_PREMIUM_AMOUNT,
    NOMINEE_RELATIONSHIP_DETAILS,
    BRISK_NOMINEE_RELATIONSHIP_DETAILS,
    PAYMENT_DETAILS,
    POLICY_TYPE_DETAILS,
    PREMIUM_PERCENTAGE,
} from "../../../Shared/CommonConstant";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "antd";
import { LocalizationProvider } from "@mui/x-date-pickers";
import {
    addWalletAmount,
    briskMakeList,
    briskModelList,
    getCutPayDetailsByUserId,
    getBriskWalletAmount,
    createBriskCertificate,
    briskPlanList,
    saveBriskCertificate,
    UpdateOnlinePolicyBriskCertificate,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import swal from "sweetalert";
import { AccountBalanceWalletIcon } from "../../../Resources/Icons/icons";
import { Button, IconButton, Tooltip } from "@mui/material";
import { RefreshOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

const initialValues = {
    totalPremium: "",
    CustomerName: "",
    MobileNo: "",
    EmailID: "",
    City: "",
    State: "",
    CustomerGender: "",
    CustomerDOB: "",
    NomineeName: "",
    NomineeGender: "",
    Relation: "",
    Make: "",
    Model: "",
    EngineNo: "",
    ChassisNo: "",
    RegistrationNo: "",
    PaymentMode: PAYMENT_DETAILS[0].value,
    policyType: POLICY_TYPE_DETAILS[0].value,
    totalPremium: "",
    netPremium: "",
    gst: "0",
    minimumPremium: 0,
    Address_Line1: "",
    Address_Line2: "",
    PlanName: "",
};

// const resetForm = () => {
//   Object.entries(initialValues).forEach(([key, value]) => {
//     // console.log(`Key: ${key}, Value: ${value}`);
//     setFieldValue(key, value);
//   });
// };

const BriskCreateCertificate = (prop) => {
    let formRef = useRef();
    const [openLoader, setOpenLoader] = useState(false);
    const [walletAmount, setWalletAmount] = useState("");
    const [walletBalance, setWalletBalance] = useState("");
    const UserType = sessionStorage.getItem("userType");
    const [isSaveAction, setIsSaveAction] = useState(false);
    let POLICY_TYPE = POLICY_TYPE_DETAILS;
    const { selectedData, isEdit } = prop;
    const [fillDOB, setFillDOB] = useState(null);
    const [minimumPremium, setMinimumPremium] = useState(MINIMUM_PREMIUM_AMOUNT);
    const [MODEL_LIST, setModelList] = useState([]);
    const [PLAN_LIST, setPlanList] = useState([]);
    const [MAKE_LIST, setMakeList] = useState([]);
    const location = useLocation();
    const editData = location.state?.certificateData;
    const isEditMode = location.state?.editMode;
    // Retry entry point from the Online Policy view. A SEPARATE flag from
    // editMode on purpose: editMode also attaches oldCertificateId below, which
    // makes Brisk treat the request as an amendment rather than a new
    // certificate. Here the policy simply never got one.
    const isPolicyPrefill = location.state?.prefillFromPolicy;
    const prefillPolicyId = location.state?.onlinePolicyId;

    if (UserType != "CLIENT") {
        POLICY_TYPE = POLICY_TYPE.slice(0, 1);
    }
    const initialLoad = async () => {
        const makeList = await briskMakeList();
        console.log("makeList ", makeList);
        // Guard: API may return an error object instead of an array
        // API may return the array directly (data) or wrapped (data.data)
        const data = Array.isArray(makeList?.data)
            ? makeList.data
            : Array.isArray(makeList?.data?.data)
                ? makeList.data.data
                : [];
        const makeArray = data.map((e) => {
            return { label: e, value: e };
        });
        console.log("makeArray ", makeArray);
        setMakeList(makeArray || []);
    };

    const CreateCertificateSchema = Yup.object().shape({
        totalPremium: Yup.number()
            .min(minimumPremium, `Total premium must be at least ${minimumPremium}`)
            .required("Total Premium Required"),
        CustomerName: Yup.string().required("Customer Name Required"),
        Address_Line1: Yup.string().required("Address Line 1 Required"),
        Address_Line2: Yup.string().required("Address Line 2 Required"),
        MobileNo: Yup.string().required("Mobile Required"),
        EmailID: Yup.string().required("Email Required"),
        City: Yup.string().required("City Required"),
        State: Yup.string().required("State Required"),
        CustomerGender: Yup.string().required("Gender Required"),
        CustomerDOB: Yup.string().required("Date of Birth Required"),
        NomineeName: Yup.string().required("Nominee Name Required"),
        NomineeGender: Yup.string().required("Nominee Gender Required"),
        Relation: Yup.string().required("Nominee Relationship Required"),
        Make: Yup.string().required("Make Required"),
        PlanName: Yup.string().required("Plan Name Required"),
        Model: Yup.string().required("Model Required"),
        EngineNo: Yup.string().required("Engine Number Required"),
        ChassisNo: Yup.string().required("Chassis Number Required"),
        RegistrationNo: Yup.string().required("Registration Number Required"),
        PaymentMode: Yup.string().required("Payment Mode Required"),
        policyType: Yup.string().required("Policy Type Required"),
    });

    const getModel = async (make) => {
        const modelList = await briskModelList(make);
        console.log("modelList ", modelList);
        // Guard: API may return an error object instead of an array
        // API may return the array directly (data) or wrapped (data.data)
        const data = Array.isArray(modelList?.data)
            ? modelList.data
            : Array.isArray(modelList?.data?.data)
                ? modelList.data.data
                : [];
        const modelArray = data.map((e) => {
            return { label: e, value: e };
        });
        setModelList(modelArray || []);
        console.log("MODEL_LIST ", MODEL_LIST);
    };

    const getPlan = async () => {
        const planList = await briskPlanList();
        console.log("planList ", planList);
        // Guard: API may return an error object instead of an array
        // API may return the array directly (data) or wrapped (data.data)
        const data = Array.isArray(planList?.data)
            ? planList.data
            : Array.isArray(planList?.data?.data)
                ? planList.data.data
                : [];
        const planArray = data.map((e) => {
            return { label: e?.PlanName, value: e?.PlanName, price: e?.TotalPrice };
        });
        setPlanList(planArray || []);
        console.log("PLAN_LIST ", planArray);
    };

    useEffect(() => {
        initialLoad();
        getPlan();
    }, []);

    const save = async (data) => {
        console.log("data :::::", data, "isSaveAction :::::", isSaveAction);
        // return true;
        let tempWalletAmount = 0;
        setOpenLoader(true);
        await getBriskWalletAmount().then((res) => {
            console.log("wallet response ", res);
            setWalletBalance(Number(res?.balance) || 0);
            tempWalletAmount = Number(res?.balance) || 0;
        });
        if (isEditMode && location.state.certificateId) {
            data.oldCertificateId = location.state.certificateId;
        }
        if (!isSaveAction && data.totalPremium > tempWalletAmount) {
            setOpenLoader(false); // Stop loader before showing error
            ToastError("Insufficient wallet balance");
            // const topupAmount = data.policyPremium - tempWalletAmount;
            // if (topupAmount) {
            //   setOpenLoader(true);
            //   addWalletAmount({ amount: Number(topupAmount) })
            //     .then((res) => {
            //       console.log("res :::", res.data);
            //       window.open(res?.data?.redirectUrl, "_blank");
            //     })
            //     .catch((err) => {
            //       ToastError(err?.response?.data?.message || "Something went wrong");
            //     })
            //     .finally(() => setOpenLoader(false));
            // }
            return true;
        }
        const response = isSaveAction
            ? await saveBriskCertificate(data)
                .then((res) => {
                    swal(res?.message);
                })
                .catch((err) => {
                    ToastError(err?.response?.data?.message || "Something went wrong");
                    return true;
                })
                .finally(() => {
                    setOpenLoader(false);
                })
            : await createBriskCertificate(data)
                .then((res) => {
                    console.log("res :::", res.data);
                    if (res?.error) {
                        ToastError(res?.message || "Something went wrong");
                        return true;
                    }
                    swal(
                        "Certicate Created successfully, Are you want to download certificate!",
                        {
                            buttons: {
                                defeat: {
                                    text: "Download",
                                },
                            },
                        }
                    ).then((value) => {
                        switch (value) {
                            case "defeat":
                                window.open(res?.downloadUrl, "_blank");
                                // resetForm();
                                break;
                        }
                    });
                    getBriskWalletAmount();

                    // Came here from an Online Policy whose certificate was
                    // never created — attach the new one to that policy so its
                    // "Brisk Certificate" card lights up.
                    //
                    // Uses the dedicated endpoint, NOT UpdateOnlinePolicy: that
                    // one re-queues the automation job server-side and would
                    // re-submit a policy that is already filed.
                    if (prefillPolicyId && res?.downloadUrl) {
                        const certificateNo =
                            res?.certificateNo ||
                            res?.data?.certificateNo ||
                            res?.CertificateNo ||
                            null;
                        UpdateOnlinePolicyBriskCertificate(prefillPolicyId, {
                            fileName: certificateNo
                                ? `brisk_${certificateNo}.pdf`
                                : "brisk_certificate.pdf",
                            location: res.downloadUrl,
                            certificateNo,
                        })
                            .then((saveRes) => {
                                if (saveRes && !saveRes.error) {
                                    ToastSuccess("Certificate attached to the policy");
                                }
                            })
                            .catch(() => {
                                // The certificate itself was created and the
                                // wallet already charged — never fail the flow
                                // just because linking it back did not stick.
                                ToastError(
                                    "Certificate created, but it could not be linked to the policy. Open it from the download link above."
                                );
                            });
                    }
                    // if (isEditMode) {
                    // navigate('/cpalist'); // Optional: redirect back to list
                    // }
                })
                .catch((err) => {
                    ToastError(err?.response?.data?.message || "Something went wrong");
                    return true;
                })
                .finally(() => {
                    setOpenLoader(false);
                });
        return response;
    };

    const handleChange = (e) => {
        setWalletAmount(e.target.value);
    };

    const calculateCutPay = (e) => {
        const totalPrem = e.target.value;
        // console.log("totalPrem ", totalPrem);
        if (minimumPremium) {
            const netPremium = (totalPrem * 100) / PREMIUM_PERCENTAGE.toFixed(2);
            const gstValue = (netPremium * GST_PERCENTAGE) / 100;
            const premium = minimumPremium + gstValue;
            // console.log("netPremium  ", netPremium);
            // console.log("gstValue  ", gstValue);
            // console.log("premium  ", Math.round(premium));
            formRef.setFieldValue("totalPremium", Math.round(premium));
            formRef.setFieldValue("netPremium", netPremium.toFixed(2));
            formRef.setFieldValue("gst", gstValue.toFixed(2));
        } else {
            formRef.setFieldValue("totalPremium", totalPrem);
        }
        formRef.setFieldValue("totalPremium", totalPrem);
    };

    useEffect(() => {
        // getWallet();
        // console.log("selectedData : ", selectedData);
        if (selectedData) {
            const daysjsDate = dayjs(
                selectedData?.payload?.CustomerDOB,
                "DD/MM/YYYY"
            );
            setFillDOB(dayjs(selectedData?.payload?.CustomerDOB));
            console.log(
                "dayjs ",
                dayjs(selectedData?.payload?.PolicyDetails?.CustomerDOB)
            );
            formRef.setFieldValue("totalPremium", selectedData.totalPremium);
            formRef.setFieldValue(
                "CustomerName",
                selectedData?.payload?.CustomerName
            );
            formRef.setFieldValue(
                "Address_Line1",
                selectedData?.payload?.Address_Line1
            );
            formRef.setFieldValue(
                "Address_Line2",
                selectedData?.payload?.Address_Line2
            );
            formRef.setFieldValue("MobileNo", selectedData?.payload?.MobileNo);
            formRef.setFieldValue("EmailID", selectedData?.payload?.EmailID);
            formRef.setFieldValue("City", selectedData?.payload?.City);
            formRef.setFieldValue("State", selectedData?.payload?.State);
            formRef.setFieldValue(
                "CustomerGender",
                selectedData?.payload?.CustomerGender
            );
            formRef.setFieldValue("CustomerDOB", daysjsDate.$d);
            formRef.setFieldValue("PlanName", selectedData?.payload?.PlanName);
            formRef.setFieldValue("NomineeName", selectedData?.payload?.NomineeName);
            formRef.setFieldValue(
                "NomineeGender",
                selectedData?.payload?.NomineeGender
            );
            formRef.setFieldValue("Relation", selectedData?.payload?.Relation);
            formRef.setFieldValue("Make", selectedData?.payload?.Make);
            formRef.setFieldValue("Model", selectedData?.payload?.Model);
            formRef.setFieldValue("EngineNo", selectedData?.payload?.EngineNo);
            formRef.setFieldValue("ChassisNo", selectedData?.payload?.ChassisNo);
            formRef.setFieldValue(
                "RegistrationNo",
                selectedData?.payload?.RegistrationNo
            );
            formRef.setFieldValue("PaymentMode", selectedData?.payload?.PaymentMode);
            formRef.setFieldValue("policyType", selectedData?.policyType);
            formRef.setFieldValue("policyPremium", selectedData?.policyPremium);
            formRef.setFieldValue("netPremium", selectedData?.netPremium);
            formRef.setFieldValue("gst", selectedData?.gst);
        }
        getCutPayDetailsByUserId().then((res) => {
            // console.log("cut pay response ", res);
            const isCutPay = res.data?.isCutPay || false;
            const minimumPrem = res.data?.minimumPremium || 0;
            if (isCutPay) {
                setMinimumPremium(minimumPrem);
                formRef.setFieldValue("minimumPremium", minimumPremium);
            }
            // console.log("minimumPrem ", minimumPrem);
            // console.log("isCutPay ", isCutPay);
            // console.log("minimumPremium ", minimumPremium);
        });
    }, [minimumPremium]);

    // Auto-fill form when editing from CPA List
    useEffect(() => {
        if ((isEditMode || isPolicyPrefill) && editData && formRef) {
            // Customer Details
            formRef.setFieldValue("CustomerName", editData?.CustomerName || "");
            formRef.setFieldValue("MobileNo", editData?.MobileNo || "");
            formRef.setFieldValue("EmailID", editData?.EmailID || "");
            formRef.setFieldValue("City", editData?.City || "");
            formRef.setFieldValue("State", editData?.State || "");
            formRef.setFieldValue("CustomerGender", editData?.CustomerGender || "");
            formRef.setFieldValue("Address_Line1", editData?.Address_Line1 || "");
            formRef.setFieldValue("Address_Line2", editData?.Address_Line2 || "");

            // Handle DOB
            if (editData?.CustomerDOB) {
                const dobDate = dayjs(editData.CustomerDOB);
                setFillDOB(dobDate);
                formRef.setFieldValue("CustomerDOB", dobDate);
            }

            // Nominee Details
            formRef.setFieldValue("NomineeName", editData?.NomineeName || "");
            formRef.setFieldValue("NomineeGender", editData?.NomineeGender || "");
            formRef.setFieldValue("Relation", editData?.Relation || "");

            // Vehicle Details
            formRef.setFieldValue("Make", editData?.Make || "");
            formRef.setFieldValue("Model", editData?.Model || "");
            formRef.setFieldValue("EngineNo", editData?.EngineNo || "");
            formRef.setFieldValue("ChassisNo", editData?.ChassisNo || "");
            formRef.setFieldValue("RegistrationNo", editData?.RegistrationNo || "");

            // Policy and Premium Details
            formRef.setFieldValue("policyType", editData?.PolicyType || "");
            formRef.setFieldValue("PlanName", editData?.SelectPlan || "");
            formRef.setFieldValue("totalPremium", editData?.TotalPremium || "");
            formRef.setFieldValue("netPremium", editData?.NetPremium || "");
            formRef.setFieldValue("PaymentMode", editData?.PaymentMode === "FromWallet" ? "Wallet" : editData?.PaymentMode || "");

            // Load model list if Make is present
            if (editData?.Make) {
                getModel(editData.Make);
            }
        }
    }, [isEditMode, isPolicyPrefill, editData]);

    const getWallet = () => {
        setOpenLoader(true);
        getBriskWalletAmount()
            .then((res) => {
                setWalletBalance(Number(res?.balance) || 0);
            })
            .catch((err) => {
                ToastError(err?.response?.data?.message || "Something went wrong");
            })
            .finally(() => {
                setOpenLoader(false);
            });
    };

    return (
        <>
            <Box
                sx={{ flexGrow: 1 }}
                style={{
                    "margin-top": isEdit ? "140px" : "0px",
                    "padding-left": isEdit ? "10px" : "0px",
                }}
            >
                <Grid container className="Master_Header_Container" sx={{ px: { xs: 1, sm: 2 } }}>
                    <Grid item xs={12} sm={3}>
                        <Typography className="Master_Header_Heading" sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}>
                            Brisk Create Certificate
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={9} />
                </Grid>
            </Box>
            <Paper sx={{
                padding: { xs: "8px 4px", sm: "10px 8px", md: "12px 16px" },
                margin: { xs: "0 4px 12px 4px", sm: "0 8px 16px 8px" }
            }}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={CreateCertificateSchema}
                    innerRef={(ref) => {
                        if (ref) {
                            formRef = ref;
                        }
                    }}
                    onSubmit={async (values, { resetForm }) => {
                        const response = await save(values);
                        if (!response) {
                            resetForm();
                        }
                    }}
                >
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form>
                            <Typography sx={{ ml: { xs: 0.5, sm: 1 }, fontSize: { xs: "0.9rem", sm: "1rem" }, fontWeight: 600, mb: 0.5 }}>Customer Details</Typography>
                            <Grid container sx={{ p: { xs: 0.5, sm: 1 } }} spacing={{ xs: 0.75, sm: 1 }}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Customer Name <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue(
                                                "CustomerName",
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                        name="CustomerName"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.CustomerName && touched.CustomerName ? (
                                            <div>{errors.CustomerName}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Date of Birth <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            name="CustomerDOB"
                                            className="Date_Picker w-100"
                                            placeholder="Select Date or Enter DD/MM/YYYY"
                                            value={fillDOB}
                                            onChange={(e) => {
                                                setFieldValue("CustomerDOB", e?.$d);
                                                // console.log("date ::: ", e.$d);
                                                setFillDOB(e);
                                            }}
                                            // key={refreshCount}
                                            format={"DD/MM/YYYY"}
                                            placement="bottomRight"
                                        />
                                    </LocalizationProvider>
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.CustomerDOB && touched.CustomerDOB ? (
                                            <div>{errors.CustomerDOB}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Gender <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={GENDER_DETAILS}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.value === value
                                        }
                                        clearIcon={false}
                                        value={values.CustomerGender}
                                        name="Gender"
                                        onChange={(option, value) => {
                                            setFieldValue("CustomerGender", value?.label);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.CustomerGender && touched.CustomerGender ? (
                                            <div>{errors.CustomerGender}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Mobile <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field className="textField w-100" name="MobileNo" />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.MobileNo && touched.MobileNo ? (
                                            <div>{errors.MobileNo}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Email <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field className="textField w-100" name="EmailID" />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.EmailID && touched.EmailID ? (
                                            <div>{errors.EmailID}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}></Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Address Line 1 <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue(
                                                "Address_Line1",
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                        name="Address_Line1"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.Address_Line1 && touched.Address_Line1 ? (
                                            <div>{errors.Address_Line1}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Address Line 2 <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue(
                                                "Address_Line2",
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                        name="Address_Line2"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.Address_Line2 && touched.Address_Line2 ? (
                                            <div>{errors.Address_Line2}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}></Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        City <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue("City", e.target.value.toUpperCase())
                                        }
                                        name="City"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.City && touched.City ? (
                                            <div>{errors.City}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        State <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue("State", e.target.value.toUpperCase())
                                        }
                                        name="State"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.State && touched.State ? (
                                            <div>{errors.State}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                            <hr />
                            <Typography sx={{ ml: { xs: 0.5, sm: 1 }, fontSize: { xs: "0.9rem", sm: "1rem" }, fontWeight: 600, mb: 0.5 }}>Nominee Details</Typography>
                            <Grid container sx={{ p: { xs: 0.5, sm: 1 } }} spacing={{ xs: 0.75, sm: 1 }}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Nominee Name <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        className="textField w-100"
                                        onChange={(e) =>
                                            setFieldValue(
                                                "NomineeName",
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                        name="NomineeName"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.NomineeName && touched.NomineeName ? (
                                            <div>{errors.NomineeName}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Nominee Gender <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={GENDER_DETAILS}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.value === value
                                        }
                                        clearIcon={false}
                                        value={values.NomineeGender}
                                        name="NomineeGender"
                                        onChange={(option, value) => {
                                            setFieldValue("NomineeGender", value?.label);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.NomineeGender && touched.NomineeGender ? (
                                            <div>{errors.NomineeGender}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Nominee Relationship <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={BRISK_NOMINEE_RELATIONSHIP_DETAILS}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.value === value
                                        }
                                        clearIcon={false}
                                        value={values.Relation}
                                        name="nomineeRelationShip"
                                        onChange={(option, value) => {
                                            setFieldValue("Relation", value?.label);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.Relation && touched.Relation ? (
                                            <div>{errors.Relation}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                            <hr />
                            <Typography sx={{ ml: { xs: 0.5, sm: 1 }, fontSize: { xs: "0.9rem", sm: "1rem" }, fontWeight: 600, mb: 0.5 }}>Vehicle Details</Typography>
                            <Grid container sx={{ p: { xs: 0.5, sm: 1 } }} spacing={{ xs: 0.75, sm: 1 }}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Make <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={MAKE_LIST}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.value === value
                                        }
                                        clearIcon={false}
                                        value={values.Make}
                                        name="make"
                                        onChange={(event, value) => {
                                            setFieldValue("Make", value?.label);
                                            getModel(value?.label);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.Make && touched.Make ? (
                                            <div>{errors.Make}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Model <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={MODEL_LIST}
                                        isOptionEqualToValue={(option, value) => {
                                            return option?.value === value;
                                        }}
                                        clearIcon={false}
                                        value={values.Model}
                                        name="model"
                                        onChange={(option, value) => {
                                            setFieldValue("Model", value?.label);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.Model && touched.Model ? (
                                            <div>{errors.Model}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}></Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Registration Number <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        name="RegistrationNo"
                                        type="text"
                                        className="textField w-100"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.RegistrationNo && touched.RegistrationNo ? (
                                            <div>{errors.RegistrationNo}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Chassis Number <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        name="ChassisNo"
                                        type="text"
                                        className="textField w-100"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.ChassisNo && touched.ChassisNo ? (
                                            <div>{errors.ChassisNo}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Engine Number <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        name="EngineNo"
                                        type="text"
                                        className="textField w-100"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.EngineNo && touched.EngineNo ? (
                                            <div>{errors.EngineNo}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                            <hr />
                            <Typography sx={{ ml: { xs: 0.5, sm: 1 }, fontSize: { xs: "0.9rem", sm: "1rem" }, fontWeight: 600, mb: 0.5 }}>Premium Details</Typography>
                            <Grid container sx={{ p: { xs: 0.5, sm: 1 } }} spacing={{ xs: 0.75, sm: 1 }}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Policy Type <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={POLICY_TYPE}
                                        clearIcon={false}
                                        value={values.policyType}
                                        name="policyType"
                                        onChange={(option, value) => {
                                            setFieldValue("policyType", value?.label);
                                        }}
                                        isOptionEqualToValue={(option, value) =>
                                            option.value === value
                                        } // Custom comparison
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.policyType && touched.policyType ? (
                                            <div>{errors.policyType}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Select Plan <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={PLAN_LIST}
                                        isOptionEqualToValue={(option, value) => {
                                            return option?.value === value;
                                        }}
                                        clearIcon={false}
                                        value={values.PlanName}
                                        name="PlanName"
                                        onChange={(option, value) => {
                                            setFieldValue("PlanName", value?.label);
                                            setFieldValue("totalPremium", value?.price);
                                            // setFieldValue("policyPremium", value?.price);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.PlanName && touched.PlanName ? (
                                            <div>{errors.PlanName}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Total Premium <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        name="totalPremium"
                                        type="number"
                                        onChange={calculateCutPay}
                                        className="textField w-100"
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.totalPremium && touched.totalPremium ? (
                                            <div>{errors.totalPremium}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                // style={{ display: minimumPremium ? "block" : "none" }}
                                >
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Net Premium <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Field
                                        name="netPremium"
                                        type="number"
                                        className="textField w-100"
                                        readOnly
                                    />
                                    {minimumPremium && (
                                        <small
                                            style={{
                                                color: "blue",
                                                display: minimumPremium ? "block" : "none",
                                            }}
                                        >
                                            {/* Minimum Premium: {minimumPremium},  */}
                                            Net Premium: {values.netPremium}, GST: {values.gst}
                                        </small>
                                    )}
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.netPremium && touched.netPremium ? (
                                            <div>{errors.netPremium}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ mb: 0.5, fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 500 }}>
                                        Payment Mode <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        className="AutoComplete_InputBox"
                                        options={PAYMENT_DETAILS}
                                        // getOptionLabel={(option) => {
                                        //   console.log("getOptionLabel ::", option);
                                        //   return option.label || "";
                                        // }}
                                        clearIcon={false}
                                        value={values.PaymentMode}
                                        name="PaymentMode"
                                        onChange={(option, value) => {
                                            setFieldValue("PaymentMode", value?.value);
                                        }}
                                        isOptionEqualToValue={(option, value) =>
                                            option.value === value
                                        } // Custom comparison
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <div className="errorMessage mb-2 mt-2">
                                        {errors.PaymentMode && touched.PaymentMode ? (
                                            <div>{errors.PaymentMode}</div>
                                        ) : (
                                            " "
                                        )}
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container sx={{ p: { xs: 0.5, sm: 1 }, mt: 1 }} spacing={{ xs: 0.75, sm: 1 }} alignItems="center">
                                <Grid item xs={12} sm="auto">
                                    <Button
                                        className="Master_Header_create_Button Common_Button"
                                        startIcon={<AccountBalanceWalletIcon />}
                                        sx={{ fontSize: { xs: "0.85rem", sm: "0.95rem" }, minWidth: { sm: "200px" } }}
                                    >
                                        Wallet Balance = {walletBalance}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm="auto">
                                    <Tooltip title="Refresh Wallet Balance">
                                        <IconButton
                                            onClick={getWallet}
                                            color="primary"
                                            aria-label="refresh"
                                        >
                                            <RefreshOutlined />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <hr />
                            {/* <Typography sx={{ ml: 2 }}>Wallet Details</Typography>
              <Grid container sx={{ p: 2 }} columnSpacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="Wallet Amount" value={walletAmount}>
                    <Field
                      name="walletAmount"
                      type="number"
                      value={walletAmount}
                      onChange={handleChange}
                      className="textField w-100"
                    />
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <button
                    className="w-100 Common_Button"
                    type="button"
                    onClick={() => addWallet(walletAmount)}
                  >
                    Wallet Topup
                  </button>
                </Grid>
              </Grid> */}
                            <Grid
                                container
                                spacing={{ xs: 1, sm: 1.5 }}
                                sx={{
                                    p: { xs: 0.5, sm: 1 },
                                    justifyContent: { xs: 'center', sm: 'flex-start' }
                                }}
                            >
                                <Grid
                                    style={{ display: isEdit ? "none" : "block" }}
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    lg={2}
                                >
                                    <Button
                                        onClick={() => setIsSaveAction(true)}
                                        variant="outlined"
                                        color="primary"
                                        type="submit"
                                        fullWidth
                                        sx={{
                                            py: 1.5,
                                            fontWeight: 600,
                                            borderWidth: 2,
                                            '&:hover': {
                                                borderWidth: 2,
                                                backgroundColor: 'primary.light',
                                                color: 'white'
                                            }
                                        }}
                                    >
                                        Save Draft
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <Button
                                        onClick={() => setIsSaveAction(false)}
                                        variant="contained"
                                        color="success"
                                        type="submit"
                                        fullWidth
                                        sx={{
                                            py: 1.5,
                                            fontWeight: 600,
                                            boxShadow: 3,
                                            '&:hover': {
                                                boxShadow: 6,
                                                backgroundColor: 'success.dark'
                                            }
                                        }}
                                    >
                                        Create Certificate
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Paper >
            <Loader open={openLoader} />
        </>
    );
};

export default BriskCreateCertificate;
